import React, { useState, useRef, useEffect } from 'react';
import { GoogleAuthProvider, signInWithPopup, onAuthStateChanged, signOut } from 'firebase/auth';
import { collection, addDoc, getDocs, updateDoc, doc, orderBy, query } from 'firebase/firestore';
import { db, auth } from './firebase';
import './App.css';

const OPENAI_API_KEY = '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';
const ANTHROPIC_API_KEY = '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';

function CalendarModal({ event, onConfirm, onCancel }) {
  const [title, setTitle] = useState(event.popis || '');
  const [datum, setDatum] = useState(event.datum || '');
  const [cas, setCas] = useState(event.cas || '');
  const [celodenná, setCelodenná] = useState(!event.cas);
  const [lokacia, setLokacia] = useState('');
  const [opakovanie, setOpakovanie] = useState(event.opakovanie || '');
  const [poznamka, setPoznamka] = useState(event.text || '');
  const [trvanie, setTrvanie] = useState(30);
  const [pripomienka, setPripomienka] = useState(30);

  const trvanieOptions = [
    { label: '15 minút', value: 15 },
    { label: '30 minút', value: 30 },
    { label: '45 minút', value: 45 },
    { label: '1 hodina', value: 60 },
    { label: '1,5 hodiny', value: 90 },
    { label: '2 hodiny', value: 120 },
    { label: '3 hodiny', value: 180 },
    { label: '4 hodiny', value: 240 },
  ];

  const pripomienkaOptions = [
    { label: '5 minút pred', value: 5 },
    { label: '10 minút pred', value: 10 },
    { label: '30 minút pred', value: 30 },
    { label: '1 hodinu pred', value: 60 },
    { label: '2 hodiny pred', value: 120 },
    { label: '1 deň pred', value: 1440 },
    { label: '2 dni pred', value: 2880 },
  ];

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>📅 Pridať do kalendára</h2>

        <label>Názov udalosti</label>
        <input value={title} onChange={e => setTitle(e.target.value)} />

        <label>Dátum</label>
        <input type="date" value={datum} onChange={e => setDatum(e.target.value)} />

        <div className="celodenná-toggle">
          <label className="toggle-label">
            <input
              type="checkbox"
              checked={celodenná}
              onChange={e => {
                setCelodenná(e.target.checked);
                if (e.target.checked) setCas('');
              }}
            />
            <span>Celodenná udalosť</span>
          </label>
        </div>

        {!celodenná && (
          <>
            <label>Čas začiatku</label>
            <input type="time" value={cas} onChange={e => setCas(e.target.value)} />

            <label>Trvanie</label>
            <div className="drum-scroll">
              {trvanieOptions.map(opt => (
                <div
                  key={opt.value}
                  className={`drum-item ${trvanie === opt.value ? 'drum-selected' : ''}`}
                  onClick={() => setTrvanie(opt.value)}
                >
                  {opt.label}
                </div>
              ))}
            </div>

            <label>Pripomienka</label>
            <div className="drum-scroll">
              {pripomienkaOptions.map(opt => (
                <div
                  key={opt.value}
                  className={`drum-item ${pripomienka === opt.value ? 'drum-selected' : ''}`}
                  onClick={() => setPripomienka(opt.value)}
                >
                  {opt.label}
                </div>
              ))}
            </div>
          </>
        )}

        <label>Lokalita</label>
        <input value={lokacia} onChange={e => setLokacia(e.target.value)} placeholder="napr. Nemocnica, Bratislava..." />

        <label>Opakovanie</label>
        <select value={opakovanie} onChange={e => setOpakovanie(e.target.value)}>
          <option value="">Žiadne</option>
          <option value="tydenne">Každý týždeň</option>
          <option value="mesacne">Každý mesiac</option>
          <option value="rocne">Každý rok</option>
        </select>

        <label>Poznámka</label>
        <textarea value={poznamka} onChange={e => setPoznamka(e.target.value)} rows={3} />

        <div className="modal-buttons">
          <button className="btn-confirm" onClick={() => onConfirm({ title, datum, cas, celodenná, lokacia, opakovanie, poznamka, trvanie, pripomienka })}>
            ✅ Pridať do kalendára
          </button>
          <button className="btn-cancel" onClick={onCancel}>
            ❌ Zrušiť
          </button>
        </div>
      </div>
    </div>
  );
}

function AppInner({ user, googleToken, onLogout }) {
  const [transcript, setTranscript] = useState('');
  const [isRecording, setIsRecording] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [notes, setNotes] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState('');
  const [pendingEvent, setPendingEvent] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  useEffect(() => {
    loadNotes();
  }, []);

  const loadNotes = async () => {
    try {
      const q = query(collection(db, 'notes'), orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      const loaded = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setNotes(loaded);
    } catch (error) {
      console.error('Chyba načítania:', error);
    }
  };

  const saveNoteToFirebase = async (note) => {
    try {
      const docRef = await addDoc(collection(db, 'notes'), {
        ...note,
        createdAt: new Date()
      });
      return docRef.id;
    } catch (error) {
      console.error('Chyba ukladania:', error);
    }
  };

  const updateNoteInFirebase = async (id, text) => {
    try {
      await updateDoc(doc(db, 'notes', id), { text });
      setNotes(prev => prev.map(n => n.id === id ? { ...n, text } : n));
      setEditingId(null);
      setEditingText('');
    } catch (error) {
      console.error('Chyba aktualizácie:', error);
    }
  };

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder = new MediaRecorder(stream);
    audioChunksRef.current = [];
    mediaRecorder.ondataavailable = (event) => {
      audioChunksRef.current.push(event.data);
    };
    mediaRecorder.start(100);
    mediaRecorderRef.current = mediaRecorder;
    setIsRecording(true);
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setIsRecording(false);
    mediaRecorderRef.current.onstop = async () => {
      const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
      await transcribeAudio(audioBlob);
    };
  };

  const transcribeAudio = async (audioBlob) => {
    setIsTranscribing(true);
    try {
      const formData = new FormData();
      formData.append('file', audioBlob, 'recording.webm');
      formData.append('model', 'whisper-1');
      formData.append('language', 'sk');
      const response = await fetch('https://api.openai.com/v1/audio/transcriptions', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${OPENAI_API_KEY}` },
        body: formData
      });
      const data = await response.json();
      setTranscript(data.text);
      await analyzeText(data.text);
    } catch (error) {
      console.error('Chyba prepisu:', error);
    }
    setIsTranscribing(false);
  };

  const analyzeText = async (text) => {
    setIsAnalyzing(true);
    try {
      const response = await fetch('https://api.anthropic.com/v1/messages', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ANTHROPIC_API_KEY,
          'anthropic-version': '2023-06-01',
          'anthropic-dangerous-direct-browser-access': 'true'
        },
        body: JSON.stringify({
          model: 'claude-sonnet-4-20250514',
          max_tokens: 1000,
          messages: [{
            role: 'user',
            content: `Analyzuj túto poznámku a urč o aký typ záznamu ide. Dnes je ${new Date().toLocaleDateString('sk-SK')}. Odpovedaj ONLY v JSON formáte bez akéhokoľvek iného textu.

Poznámka: "${text}"

Odpovedaj takto:
{
  "typ": "poznamka" | "kalendar" | "pripomienka",
  "popis": "krátky popis čo treba urobiť",
  "datum": "dátum vo formáte YYYY-MM-DD ak je spomenutý, inak null",
  "cas": "čas vo formáte HH:MM ak je spomenutý, inak null",
  "opakovanie": "rocne" | "mesacne" | "tydenne" | null
}`
          }]
        })
      });
      const data = await response.json();
      const rawText = data.content[0].text.replace(/```json|```/g, '').trim();
      const result = JSON.parse(rawText);

      const newNote = {
        text,
        time: new Date().toLocaleString('sk-SK'),
        ...result
      };

      const firebaseId = await saveNoteToFirebase(newNote);
      setNotes(prev => [{ id: firebaseId, ...newNote }, ...prev]);
      setTranscript('');

      if ((result.typ === 'kalendar' || result.typ === 'pripomienka') && googleToken) {
        setPendingEvent({ ...result, text });
      }
    } catch (error) {
      console.error('Chyba analýzy:', error);
    }
    setIsAnalyzing(false);
  };

  const handleCalendarConfirm = async (eventData) => {
    setPendingEvent(null);
    await addToGoogleCalendar(eventData);
  };

  const addToGoogleCalendar = async (eventData) => {
    try {
      const { title, datum, cas, celodenná, lokacia, opakovanie, poznamka, trvanie, pripomienka } = eventData;

      const calcEndTime = (startCas, minuty) => {
        const [h, m] = startCas.split(':').map(Number);
        const total = h * 60 + m + minuty;
        return `${String(Math.floor(total / 60) % 24).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
      };

      const event = {
        summary: title,
        description: poznamka,
        location: lokacia,
        start: celodenná
          ? { date: datum }
          : { dateTime: `${datum}T${cas}:00`, timeZone: 'Europe/Bratislava' },
        end: celodenná
          ? { date: datum }
          : { dateTime: `${datum}T${calcEndTime(cas, trvanie)}:00`, timeZone: 'Europe/Bratislava' },
        recurrence: opakovanie === 'rocne' ? ['RRULE:FREQ=YEARLY'] :
                    opakovanie === 'mesacne' ? ['RRULE:FREQ=MONTHLY'] :
                    opakovanie === 'tydenne' ? ['RRULE:FREQ=WEEKLY'] : [],
        reminders: celodenná ? { useDefault: false } : {
          useDefault: false,
          overrides: [{ method: 'popup', minutes: pripomienka }]
        }
      };

      const response = await fetch('https://www.googleapis.com/calendar/v3/calendars/primary/events', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${googleToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(event)
      });
      const data = await response.json();
      if (data.id) alert(`✅ Pridané do Google Kalendára: ${title}`);
    } catch (error) {
      console.error('Chyba kalendára:', error);
    }
  };

  const getTypIcon = (typ) => {
    if (typ === 'kalendar') return '📅';
    if (typ === 'pripomienka') return '⏰';
    return '📝';
  };

  const getTypLabel = (typ) => {
    if (typ === 'kalendar') return 'Kalendár';
    if (typ === 'pripomienka') return 'Pripomienka';
    return 'Poznámka';
  };

  return (
    <div className="app">
      <h1>🧠 br-ai-n</h1>

      {pendingEvent && (
        <CalendarModal
          event={pendingEvent}
          onConfirm={handleCalendarConfirm}
          onCancel={() => setPendingEvent(null)}
        />
      )}

      <div className="user-bar">
        <span className="user-name">👤 {user.displayName}</span>
        {googleToken
          ? <span className="google-connected">✅ Kalendár pripojený</span>
          : <span className="google-connected">📅 Kalendár nie je pripojený (prihláste sa znova)</span>
        }
        <button className="btn-logout" onClick={onLogout}>Odhlásiť</button>
      </div>

      <button
        className={isRecording ? 'btn-recording' : 'btn-start'}
        onClick={isRecording ? stopRecording : startRecording}
        disabled={isTranscribing || isAnalyzing}
      >
        {isRecording ? '⏹ Zastaviť' : '🎙️ Nahrávať'}
      </button>

      {isTranscribing && <p className="status">⏳ Prepisujem...</p>}
      {isAnalyzing && <p className="status">🤖 Analyzujem...</p>}

      {transcript && (
        <div className="transcript-box">{transcript}</div>
      )}

      {notes.length > 0 && (
        <div className="notes-section">
          <h2>📋 História poznámok</h2>
          {notes.map(note => (
            <div key={note.id} className={`note-item note-${note.typ}`}>
              <div className="note-header">
                <span className="note-typ">{getTypIcon(note.typ)} {getTypLabel(note.typ)}</span>
                <span className="note-time">{note.time}</span>
              </div>

              {editingId === note.id ? (
                <div className="edit-box">
                  <textarea
                    value={editingText}
                    onChange={e => setEditingText(e.target.value)}
                    rows={3}
                  />
                  <button className="btn-confirm" onClick={() => updateNoteInFirebase(note.id, editingText)}>✅ Uložiť</button>
                  <button className="btn-cancel" onClick={() => setEditingId(null)}>❌ Zrušiť</button>
                </div>
              ) : (
                <>
                  <p className="note-text">{note.text}</p>
                  <button className="btn-edit" onClick={() => { setEditingId(note.id); setEditingText(note.text); }}>✏️ Editovať</button>
                </>
              )}

              {note.popis && <p className="note-popis">💡 {note.popis}</p>}
              {note.datum && <p className="note-detail">📅 {note.datum}</p>}
              {note.cas && <p className="note-detail">🕐 {note.cas}</p>}
              {note.opakovanie && <p className="note-detail">🔁 {note.opakovanie}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function App() {
  const [user, setUser] = useState(null);
  const [googleToken, setGoogleToken] = useState(() => localStorage.getItem('googleToken'));
  const [authLoading, setAuthLoading] = useState(true);
  const [loginError, setLoginError] = useState('');

  useEffect(() => {
    let authFired = false;
    let redirectDone = false;

    const tryFinish = () => {
      if (authFired && redirectDone) setAuthLoading(false);
    };

    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
      authFired = true;
      redirectDone = true;
      tryFinish();
    });

    return unsubscribe;
  }, []);

  const handleLogin = async () => {
    setLoginError('');
    const provider = new GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/calendar');
    try {
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (credential?.accessToken) {
        setGoogleToken(credential.accessToken);
        localStorage.setItem('googleToken', credential.accessToken);
      }
    } catch (err) {
      setLoginError('Chyba: ' + err.code + ' — ' + err.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    setUser(null);
    setGoogleToken(null);
    localStorage.removeItem('googleToken');
  };

  if (authLoading) {
    return (
      <div className="login-screen">
        <h1>🧠 br-ai-n</h1>
        <p className="status">Načítavam...</p>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="login-screen">
        <h1>🧠 br-ai-n</h1>
        <p className="login-subtitle">Hlasom riadený zápisník s AI</p>
        <button className="btn-google-login" onClick={handleLogin}>
          <svg viewBox="0 0 24 24" width="20" height="20"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Prihlásiť sa cez Google
        </button>
        {loginError && <p className="login-error">{loginError}</p>}
      </div>
    );
  }

  return <AppInner user={user} googleToken={googleToken} onLogout={handleLogout} />;
}

export default App;
